<div class="header background-white">
  <div class="left-side-header flex-directionRow-alignCenter">
    <img [src]="localImages.smartAccountingLogo" alt="" height="64" width="64" class="m-16 cursor-pointer" (click)="redirectToMainPage()">
    <span class="header-text">{{ 'cloudFinances' | translate }}</span>
  </div>
  <div class="right-side-header flex-directionRow-alignCenter">
    <div class="header-button">
      <app-button [data]="{key: 'logOut'}" (click)="logOut()" [isLogoutButton]="true"></app-button>
    </div>
    <img [src]="localImages.userIcon" alt="" height="48" width="48" class="mt-mb-24-ml-mr-32 cursor-pointer" (click)="openClientDialog()">
  </div>
</div>
